import type { VisitContent } from "./visit-model.js";
export interface VisitDocumentAssistant { extract(bytes: Uint8Array, mime: string, signal?: AbortSignal): Promise<VisitContent> }
export class DocumentError extends Error { constructor(public readonly code: "INVALID_IMAGE" | "AI_LIMIT_REACHED" | "AI_TIMEOUT" | "AI_UNAVAILABLE" | "AI_INVALID_RESPONSE") { super(code); } }
export const IMAGE_BYTES = 6 * 1024 * 1024;
export const IMAGE_PIXELS = 20_000_000;
